var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.quotes
    ? _c("div", { staticClass: "dashboard-table-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "pagination-container",
            staticStyle: { height: "auto !important" }
          },
          [
            _c("paginate", {
              attrs: {
                "page-count": _vm.pagination.page_count,
                "click-handler": _vm.paginate,
                "hide-prev-next": true,
                "prev-text": "<",
                "next-text": ">",
                "prev-link-class": "pagination-item pagination-prev",
                "next-link-class": "pagination-item pagination-prev",
                "page-link-class": "pagination-item",
                "active-class": "pagination-item-active",
                "container-class": "pagination"
              },
              model: {
                value: _vm.pagination.page,
                callback: function($$v) {
                  _vm.$set(_vm.pagination, "page", $$v)
                },
                expression: "pagination.page"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _vm.selectedQuotes.length > 0
            ? _c("div", [
                _c(
                  "a",
                  {
                    staticStyle: { cursor: "pointer", color: "#b50a78" },
                    on: {
                      click: function($event) {
                        return _vm.massDestroy()
                      }
                    }
                  },
                  [_vm._v("Delete selected")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "table",
            { staticClass: "dashboard-table", attrs: { id: "quotes-table" } },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _c("input", {
                      attrs: { id: "toggleCheckboxesIndex", type: "checkbox" },
                      on: {
                        change: function($event) {
                          return _vm.toggleCheckboxes($event)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("id")
                        }
                      }
                    },
                    [
                      _vm._v("\n          ID\n          "),
                      _vm.currentSort === "id" && _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "id" && _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("user.name")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Name\n          "),
                      _vm.currentSort === "user.name" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "user.name" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("user.email")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Email\n          "),
                      _vm.currentSort === "user.email" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "user.email" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("user.company_name")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Company name\n          "),
                      _vm.currentSort === "user.company_name" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "user.company_name" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("user.contact_phone")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Contact phone\n          "),
                      _vm.currentSort === "user.contact_phone" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "user.contact_phone" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("office_address")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Office address\n          "),
                      _vm.currentSort === "office_address" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "office_address" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("office_postcode")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Office postcode\n          "),
                      _vm.currentSort === "office_postcode" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "office_postcode" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("th", [_vm._v("Preferences")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("updated_at")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Updated at\n          "),
                      _vm.currentSort === "updated_at" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "updated_at" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      on: {
                        click: function($event) {
                          return _vm.sort("created_at")
                        }
                      }
                    },
                    [
                      _vm._v("\n          Created at\n          "),
                      _vm.currentSort === "created_at" &&
                      _vm.currentSortDir == "desc"
                        ? _c("i", { staticClass: "fas fa-arrow-down" })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentSort === "created_at" &&
                      _vm.currentSortDir == "asc"
                        ? _c("i", { staticClass: "fas fa-arrow-up" })
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("td"),
                  _vm._v(" "),
                  _c("td"),
                  _vm._v(" "),
                  _c("td"),
                  _vm._v(" "),
                  _c("th", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("th", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("th", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("th", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("th", [_vm._v(" ")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.quotes, function(quote) {
                  return _c("tr", [
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.checkboxes[quote.id],
                            expression: "checkboxes[quote.id]"
                          }
                        ],
                        attrs: { id: "IndexQuoteList", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.checkboxes[quote.id])
                            ? _vm._i(_vm.checkboxes[quote.id], null) > -1
                            : _vm.checkboxes[quote.id]
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.checkboxes[quote.id],
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.checkboxes,
                                    quote.id,
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.checkboxes,
                                    quote.id,
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.checkboxes, quote.id, $$c)
                            }
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(quote ? quote.id : null))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(quote.user ? quote.user.name : null))
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(quote.user ? quote.user.email : null))
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(quote.user ? quote.user.company_name : null)
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(quote.user ? quote.user.contact_phone : null)
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(quote.office_address))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "cell-postcode" }, [
                      _vm._v(_vm._s(quote.office_postcode))
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "value" }, [
                      quote.user.preferences
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                quote.user.preferences.preferences_email
                                  ? "- email <br>"
                                  : null
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      quote.user.preferences
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                quote.user.preferences.preferences_mail
                                  ? "- mail <br>"
                                  : null
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      quote.user.preferences
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                quote.user.preferences.preferences_phone
                                  ? "- phone <br>"
                                  : null
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      quote.user.preferences
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                quote.user.preferences.preferences_sms
                                  ? "- sms <br>"
                                  : null
                              )
                            }
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(quote.updated_at))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(quote.created_at))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        quote
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  tag: "a",
                                  to: {
                                    name: "proposal.calculations",
                                    params: { id: quote.uniqid }
                                  }
                                }
                              },
                              [_vm._v("Proposal calculations")]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        quote
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  tag: "a",
                                  to: {
                                    name: "proposal.summary",
                                    params: { id: quote.uniqid }
                                  },
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Proposal Summary")]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.loadQuote(quote.id, 1)
                            }
                          }
                        },
                        [_vm._v("Step1")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      quote.step2
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  return _vm.loadQuote(quote.id, 2)
                                }
                              }
                            },
                            [_vm._v("Step2")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !quote.step2
                        ? _c("span", { staticStyle: { color: "grey" } }, [
                            _vm._v("Step2")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      quote.step3
                        ? _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  return _vm.loadQuote(quote.id, 3)
                                }
                              }
                            },
                            [_vm._v("Step3")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !quote.step3
                        ? _c("span", { staticStyle: { color: "grey" } }, [
                            _vm._v("Step3")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              tag: "a",
                              to: {
                                name: "results.index",
                                params: { quote_id: quote.uniqid }
                              }
                            }
                          },
                          [_vm._v("Results")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        quote.order
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  tag: "a",
                                  to: {
                                    name: "orders.index",
                                    params: { id: quote.order.uniqid }
                                  }
                                }
                              },
                              [_vm._v("Order")]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          staticStyle: { cursor: "pointer", color: "#b50a78" },
                          on: {
                            click: function($event) {
                              return _vm.destroy(quote.id)
                            }
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba8ae54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba8ae54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Index.vue
// module id = null
// module chunks = 